import { render, staticRenderFns } from "./ProductFormCmp.vue?vue&type=template&id=2be05f7c&scoped=true&"
import script from "./ProductFormCmp.vue?vue&type=script&lang=js&"
export * from "./ProductFormCmp.vue?vue&type=script&lang=js&"
import style0 from "./ProductFormCmp.vue?vue&type=style&index=0&id=2be05f7c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2be05f7c",
  null
  
)

export default component.exports